/**
 * Validation utilities for AWS Training Assistant
 */

/**
 * Validates a question string
 * 
 * @param question - The question string to validate
 * @returns true if the question is valid (non-empty and not just whitespace), false otherwise
 * 
 * Requirements: 1.1 - Validate that the question is not empty
 */
export function validateQuestion(question: string): boolean {
  // Check if question is empty or contains only whitespace
  if (!question || question.trim() === '') {
    return false;
  }
  
  return true;
}
